/* eslint-disable */
export default {
  noActiveCalls: '无进行中的通话',
  noRecords: '找不到结果。',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
